export const DEFAULT_REGION = 'ua-1'
export const REGISTRATION_REGION_SESSION_KEY = 'registration_region_confirmed'

const DISABLED_REGIONS = ['pl-1']

export const toStoredRegion = (region?: string | null) => {
  const normalizedRegion = region?.trim().toLowerCase()

  if (!normalizedRegion || normalizedRegion === 'dev') {
    return undefined
  }

  return normalizedRegion.includes('-') ? normalizedRegion : `${normalizedRegion}-1`
}

export const normalizeRegion = (region?: string | null) => {
  const storedRegion = toStoredRegion(region)

  if (!storedRegion || DISABLED_REGIONS.includes(storedRegion)) {
    return DEFAULT_REGION
  }

  return storedRegion
}

export const isS3AvailableRegion = (region?: string | null) =>
  normalizeRegion(region) === DEFAULT_REGION

export const getStoredRegion = () => {
  const normalizedRegion = normalizeRegion(localStorage.getItem('region_ocp_zone'))

  localStorage.setItem('region_ocp_zone', normalizedRegion)

  return normalizedRegion
}

export const setStoredRegion = (region?: string | null) => {
  const normalizedRegion = normalizeRegion(region)

  localStorage.setItem('region_ocp_zone', normalizedRegion)

  return normalizedRegion
}

type RegistrationRegionOwner = string | number | null | undefined

const getRegistrationRegionConfirmation = (
  region?: string | null,
  owner?: RegistrationRegionOwner,
) => `${String(owner ?? '')}:${normalizeRegion(region)}`

export const confirmRegistrationRegion = (
  region?: string | null,
  owner?: RegistrationRegionOwner,
) => {
  const normalizedRegion = normalizeRegion(region)

  sessionStorage.setItem(
    REGISTRATION_REGION_SESSION_KEY,
    getRegistrationRegionConfirmation(normalizedRegion, owner),
  )

  return normalizedRegion
}

export const isRegistrationRegionConfirmed = (
  region?: string | null,
  owner?: RegistrationRegionOwner,
) => sessionStorage.getItem(REGISTRATION_REGION_SESSION_KEY) ===
  getRegistrationRegionConfirmation(region, owner)
